import type { CreateMakeDto, Make, UpdateMakeDto } from '@/entities/make.entity';
import { Service } from './http-service';

export const makesService = new Service<Make, CreateMakeDto, UpdateMakeDto>('/makes');
